export default "__VITE_ASSET__COn4w5Jf__"